import styled from 'styled-components'
import { Button } from '~/shared/ui/Buttons'

export const ButtonRepeat = styled(Button)`
  font-size: 14px;
  font-weight: 400;
`
